import moment from 'moment-timezone';

export class EnterpriseDashboardBudgetGroupedContract {
	/** Set by the datagrid when used as a grid row for a unique key. */
	public id?: string;

	public originContractId: string;
	public dbaName: string;
	public referenceBudgetYearDate: Date;
	public referenceBudgetCost: number;
	public actualCost: number;
	public currentBudgetCost: number;
	public varianceAmount: number;
	public variancePercent: number;
	public currentBudgetCostDiffPercent: number;
	public locationAddress1: string;
	public locationAddress2: string;
	public locationCity: string;
	public locationZipCode: string;

	constructor(enterpriseDashboardBudgetGroupedContract?: EnterpriseDashboardBudgetGroupedContract) {
		Object.assign(this, enterpriseDashboardBudgetGroupedContract);

		this.referenceBudgetYearDate = this.referenceBudgetYearDate ? new Date(moment(this.referenceBudgetYearDate).format('MMM DD, YYYY 00:00:00 a')) : this.referenceBudgetYearDate;
	}
}
